import React, {
  useCallback,
  useContext,
  useMemo,
  useEffect,
  useRef,
  useState,
} from "react";
import { ContextStore } from "Reducer";
import { useTranslation } from "react-i18next";
import { Map, List, fromJS } from "immutable";
import useMediaQuery from "useHooks/gameMediaQuery";
import { sify } from "chinese-conv";
import { useHistory } from "react-router-dom";
import useScrollTop from "useHooks/useScrollTop";
// comp
import GameListEmpty from "./GameListEmpty";
import Search from "./Search";
import Game from "./Game";
import PayoutRankBar from "./PayoutRankBar";
import Footer from "./Footer";
import FeaturedGames from "./FeaturedGames";
import GoTopDesktop from "Components/GoTopDesktop";
// import Game from "./Game"
import PopModal from "./PopModal";
// api
import { memberSystemLink, putUpdateFavorite, getGameLink } from "api";

// util
import { transToLowercaseAndTrim, gameLinkLang } from "Utils/index";

// styled
import {
  Main,
  MainContainer,
  MaxWidthContainer,
} from "Components/common/MainStyled";
export default ({ homeScrollTop }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [gamePopup, setGamePopup] = useState(false);
  const stickyHeight = 150;
  const containerRef = useRef();
  const {
    state: { stateReducer },
    dispatch,
  } = useContext(ContextStore);
  const lang = stateReducer.get("lang");
  const searchValue = stateReducer.get("searchValue");
  const gameType = stateReducer.get("gameType");
  const typeList = stateReducer.get("typeList");
  const favorite_game = stateReducer.getIn(
    ["userInfo", "favorite_game"],
    List()
  );
  const mainAreaRoute = stateReducer.get("mainAreaRoute");
  const featuredGames = stateReducer.get("featuredGames");
  const gameList = stateReducer.get("gameList", List());
  const gameUrl = stateReducer.get("gameUrl");
  const popModalData = stateReducer.get("popModalData");
  const isLoading = stateReducer.get("isLoading");
  const scrollTop = useScrollTop(containerRef);
  const { t } = useTranslation();
  const mediaType = useMediaQuery();
  const typeValue = gameType.getIn(["value", "type"]);
  const history = useHistory();
  const cornerTagList = stateReducer.get("cornerTagList", List());

  const payoutRankTop5 = stateReducer
    .get("payoutRank", List())
    .sort((a, b) => a.get("topGamesRank") - b.get("topGamesRank"))
    .slice(0, 5);
  const gaClass = {
    Slot: "gav2_category_slot",
    Fishing: "gav2_category_fishing",
    Arcade: "gav2_category_arcade",
    Table: "gav2_category_table",
  };
  const menu =
    mediaType === "web"
      ? fromJS([
          {
            name: "allGames",
            type: "all",
            gaClass: "gav2_category_all",
          },
        ])
      : fromJS([
          {
            name: "allGames",
            type: "all",
            gaClass: "gav2_category_all",
          },
          {
            name: "favorite",
            type: "like",
            gaClass: "gav2_category_favorite",
          },
        ]);
  const menuList = useMemo(() => {
    const newTypeList = typeList.map((v) =>
      Map({
        name: v.getIn(["name", lang]),
        type: v.get("id"),
        gaClass: gaClass[v.getIn(["name", "en"])],
      })
    );
    const newMenu = menu.concat(newTypeList);
    return newMenu;
  }, [gaClass, lang, menu, typeList]);

  const filteredGameList = useMemo(() => {
    // if search return search result
    if (searchValue) {
      return gameList.filter((v) => {
        const name = v.getIn(["name", lang], v.getIn(["name", "en"], ""));
        const transName = sify(transToLowercaseAndTrim(name));
        const transSearchValue = sify(transToLowercaseAndTrim(searchValue));
        return transName.includes(transSearchValue);
      });
      // check if user choose  game type menu
    } else {
      if (typeValue === "all") return gameList;
      else if (typeValue === "like")
        return gameList.filter((v) => favorite_game.includes(v.get("game_id")));
      else if (List.isList(typeValue))
        return gameList.filter((v) => typeValue.includes(v.get("game_id")));
      else if (Number.isInteger(typeValue))
        return gameList.filter((v) => v.get("type") === typeValue);
      else return gameList;
    }
  }, [favorite_game, gameList, lang, searchValue, typeValue]);

  const featuredGameList = () => {
    const newList = [];
    featuredGames.forEach((elm) => {
      if (gameList.some((v) => v.get("game_id") === elm)) {
        newList.push(
          gameList.get(gameList.findIndex((a) => a.get("game_id") === elm))
        );
      }
    });
    return fromJS(newList);
  };
  const filteredFavoriteGameList = gameList.filter((v) =>
    favorite_game.includes(v.get("game_id"))
  );
  const favorite_gameIdList = filteredFavoriteGameList.map((v) =>
    v.get("game_id")
  );
  const handleHeartClick = (e, game_id, isFavorite) => {
    let favor_game;
    if (isFavorite) {
      favor_game = favorite_gameIdList.filter((v) => v !== game_id);
    } else {
      favor_game = favorite_gameIdList.push(game_id);
    }
    favor_game = favor_game.toJS();
    putUpdateFavorite({ favor_game }, dispatch, history);
    e.stopPropagation();
  };

  const handleOpenPopModal = ({
    game_id,
    icon,
    type,
    isFavorite,
    name,
    source,
  }) => {
    if (game_id === "999") {
      memberSystemLink(gameLinkLang(lang));
      return;
    }
    setGamePopup(!gamePopup);
    const params = {
      lang: gameLinkLang(lang),
      game_plat: mediaType,
      game_hall: "cq9",
      gamecode: game_id,
    };

    dispatch({
      type: "CHANGE_DATA",
      path: "popModalData",
      value: {
        game_id,
        icon,
        type,
        isFavorite,
        name,
        source,
      },
    });
    getGameLink({ params, history, dispatch, icon, type, isFavorite, name });
  };
  const handleOpenGame = (e) => {
    // window.open(gameUrl);
    closeGameModal();
    e.stopPropagation();
  };
  const clearSearchValue = () => {
    dispatch({ type: "CHANGE_DATA", path: "searchValue", value: "" });
  };

  const handleMenuClick = (value) => {
    clearSearchValue();
    dispatch({ type: "CHANGE_DATA", path: "gameType", value });
  };
  const closeGameModal = useCallback(() => {
    setGamePopup(false);
    dispatch({ type: "CHANGE_DATA", path: "gameUrl", value: "" });
  }, [dispatch]);

  useEffect(() => {
    if (mediaType === "web") {
      if (scrollTop > stickyHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    } else {
      if (homeScrollTop > stickyHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    }
  }, [homeScrollTop, mediaType, scrollTop]);

  return (
    <MainContainer ref={containerRef} mainAreaRoute={mainAreaRoute}>
      <MaxWidthContainer>
        {payoutRankTop5.size > 0 && (
          <PayoutRankBar payoutRankTop5={payoutRankTop5} dispatch={dispatch} />
        )}
        <Search
          isSticky={isSticky}
          searchValue={searchValue}
          t={t}
          gameType={gameType}
          handleMenuClick={handleMenuClick}
          menuList={menuList}
          clearSearchValue={clearSearchValue}
          filteredGameListSize={filteredGameList.size}
        />
        {!searchValue && featuredGames.size > 0 && (
          <FeaturedGames
            t={t}
            gameList={featuredGameList()}
            typeList={typeList}
            lang={lang}
            favorite_game={favorite_game}
            handleOpenPopModal={handleOpenPopModal}
          />
        )}

        <Main onClick={() => {}}>
          <Game
            mainAreaRoute={mainAreaRoute}
            gameList={filteredGameList}
            gameType={gameType}
            typeList={typeList}
            lang={lang}
            t={t}
            favorite_game={favorite_game}
            handleHeartClick={handleHeartClick}
            handleOpenPopModal={handleOpenPopModal}
            isLoading={isLoading}
            cornerTagList={cornerTagList}
            searchValue={searchValue}
          />
          <PopModal
            gamePopup={gamePopup}
            gameUrl={gameUrl}
            modalData={popModalData}
            closeGameModal={closeGameModal}
            handleHeartClick={handleHeartClick}
            handleOpenGame={handleOpenGame}
            favorite_game={favorite_game}
            lang={lang}
            t={t}
          />
          {!isLoading && (
            <GameListEmpty
              searchValue={searchValue}
              filteredGameList={filteredGameList}
              typeValue={typeValue}
            />
          )}
        </Main>
        <Footer />
        {isSticky && <GoTopDesktop target={containerRef?.current} />}
      </MaxWidthContainer>
    </MainContainer>
  );
};
